import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import { title } from "utils";
import { userActions } from "actions";
import { userService } from "services";
import { Logo, Header } from "components";

class QuickLoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = { users: [], loading: true };
  }

  componentDidMount() {
    userService
      .quickLoginUsers()
      .then((users) => this.setState({ users, loading: false }))
      .catch(() => this.setState({ users: [], loading: false }));
  }

  render() {
    const { users, loading } = this.state;

    return (
      <Fragment>
        <Helmet>
          {title("Connexion rapide")}
          <body data-login="true" />
        </Helmet>

        <div className="login-page quick-login-page page-content">
          <Logo />

          <div className="main-content">
            <Header title="Connexion rapide" />

            {loading ? (
              <p>Chargement…</p>
            ) : (
              <ul className="quick-login-list">
                {users.map((user) => (
                  <li key={user.id}>
                    <button
                      type="button"
                      className="quick-login-user"
                      onClick={() => this.props.quickLoginUser(user.id)}
                    >
                      <span className="quick-login-user-name">
                        {user.name} {user.surname}
                      </span>
                      <span className="quick-login-user-email">{user.email}</span>
                      {(user.user_type || {}).label && (
                        <span className="quick-login-user-type">{user.user_type.label}</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    quickLoginUser: (id) => dispatch(userActions.quickLogin(id)),
  };
};

export default connect(null, mapDispatchToProps)(QuickLoginPage);
